import React, { useContext } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { Path } from "paths";
import { CategoryList, CreateCategory, EditCategory, EditProduct } from "modules";
import ProductList from "modules/product/product-list/product-list.module";
import CreateProductForm from "modules/product/create-product/create-product.module";
import CreateProductSet from "modules/product/create-product-set/create-product-set.module";
import EditProductSet from "modules/product/edit-product-set/edit-product-set.module";
import { useMount } from "hooks";
import { setPageTitle } from "services";
import { VenueContext } from "contexts";
import { isOdooCategoryLocked, isOdooProductLocked } from "services/venue.service";

const ProductPage = () => {
  const { venue } = useContext(VenueContext);
  // A locked venue creates these in Odoo, so a typed-in create URL goes back to the list.
  const productLocked = isOdooProductLocked(venue);
  const categoryLocked = isOdooCategoryLocked(venue);

  useMount(() => {
    setPageTitle("selling");
  });
  return (
    <Switch>
      <Route exact path={Path.EDIT_PRODUCT} component={EditProduct} />
      {productLocked && <Redirect exact from={Path.CREATE_PRODUCT} to={Path.PRODUCT} />}
      {productLocked && <Redirect exact from={Path.CREATE_PRODUCT_SET} to={Path.PRODUCT} />}
      <Route exact path={Path.CREATE_PRODUCT} component={CreateProductForm} />
      <Route exact path={Path.CREATE_PRODUCT_SET} component={CreateProductSet} />
      <Route exact path={Path.EDIT_PRODUCT_SET} component={EditProductSet} />
      <Route exact path={Path.PRODUCT} component={ProductList} />
      <Route exact path={Path.CATEGORY} component={CategoryList} />
      {categoryLocked && <Redirect exact from={Path.CATEGORY_CREATE} to={Path.CATEGORY} />}
      <Route exact path={Path.CATEGORY_CREATE} component={CreateCategory} />
      <Route exact path={Path.CATEGORY_EDIT} component={EditCategory} />
    </Switch>
  );
};

export default ProductPage;
